import Vue from 'vue'
import Vuex from 'vuex'
import SDKComponent from './modules/SDKComponent'
import getters from './getters'

Vue.use(Vuex)

// 实例化 store
const store = new Vuex.Store({
  // strict: true,
  modules: {
    SDKComponent
  },
  getters
})

export default store
